var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;fill-opacity:0;}.cls-2,.cls-3{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-width:2px;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_24_Paperplane",
    "data-name": "24_Paperplane"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    className: "cls-1",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1,11.21c.73-3.05,20.62-7.73,21.79-7.16S19.32,20.11,15.86,21c-1.8.44-4.7-5.6-5.87-5.42-.71.11-1.56,2.32-2,2.09-.7-.33,0-2.56-1-3.3S.6,13,1,11.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7,14.35A100.3,100.3,0,0,1,22.81,4.05s-8.7,7.48-13.29,11.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.09,17.65a8.09,8.09,0,0,0,2.85-1.16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplane);
export default __webpack_public_path__ + "static/media/paperplane.cf2fff5a4f85bf14ab8b18f5ad6afcea.svg";
export { ForwardRef as ReactComponent };